module.exports = __webpack_public_path__ + "img/476212230-2.50f7139b.png";